import { Checkbox } from 'antd'
import { CheckboxOptionType } from 'antd/es/checkbox/Group'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './pure-checkbox.module.scss'

type CheckboxProps = {
  style?: any
  // TODO fix
  value: any
  options: CheckboxOptionType[]
  label?: string
  placeholder?: string
  colClass?: string
  moduleStyle?: string
  icon?: React.ReactNode
  name?: string
  error?: string | string[]
  required?: boolean
  size?: SizeType
  type?: string
  className?: string
  disabled?: boolean
  selectAll?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const PureCheckbox: React.FC<CheckboxProps> = ({
  value,
  label,
  colClass,
  moduleStyle,
  error,
  disabled,
  onChange,
  required = true,
  className = '',
  selectAll = true,
  options = [],
}) => {
  const { t } = useTranslation()

  const [checkedList, setCheckedList] = useState<string[]>([])
  const checkAll = options.length > 0 && options.length === checkedList.length
  const indeterminate = checkedList.length > 0 && checkedList.length < options.length

  const handleChange = (list: any) => {
    setCheckedList(list as string[])
    onChange?.(list)
  }

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.inputStyles, className)}>
      {label ? (
        <div className="label d-block mt-2 mb-1 fs-6">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}

      <div className={clsx('d-flex', 'flex-column')}>
        {selectAll ? (
          <Checkbox
            checked={checkAll}
            disabled={disabled}
            indeterminate={indeterminate}
            onChange={(e) => setCheckedList(e.target.checked ? (options as any) : [])}
          >
            {t('common.checkAll')}
          </Checkbox>
        ) : null}

        <Checkbox.Group
          className={clsx('d-flex', 'flex-column')}
          disabled={disabled}
          onChange={handleChange}
          options={options}
          value={checkedList}
        />
      </div>
      {error ? <div className="error-message">{error}</div> : null}
    </div>
  )
}
